export default {"src":"/_next/static/media/logo-hyundaicapital.9d2d2b9f.svg","height":120,"width":232,"blurWidth":0,"blurHeight":0};